import * as React from "react";
const SvgFlameinline = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", viewBox: "0 0 512 512", ...props }, /* @__PURE__ */ React.createElement("title", null, "ionicons-v5-m"), /* @__PURE__ */ React.createElement("path", { d: "M112,320c0-93,124-165,96-272,66,0,192,96,192,272a144,144,0,0,1-288,0Z", style: {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
} }), /* @__PURE__ */ React.createElement("path", { d: "M320,368c0,57.71-32,80-64,80s-64-22.29-64-80,40-86,32-128C266,240,320,310.29,320,368Z", style: {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
} }));
export default SvgFlameinline;
